import { ReactElement } from 'react'
import { Box, Stack, Switch } from '@mui/material'
import {
  GridToolbarContainer,
  GridToolbarFilterButton,
  GridToolbarQuickFilter,
} from '@mui/x-data-grid-premium'

interface Props {
  loadsCombined: boolean
  onLoadsCombinedChange: (value: boolean) => void
}

/**
 * Filter + quick-search header of the Einwirkungen tables with the "Lasten zusammenfassen"
 * switch — same layout as the element load tables' toolbar.
 */
const LoadResultsToolbar = ({ loadsCombined, onLoadsCombinedChange }: Props): ReactElement => (
  <GridToolbarContainer>
    <Stack direction="row" spacing={2} sx={{ width: '100%', alignItems: 'center' }}>
      <GridToolbarFilterButton slotProps={{ button: { size: 'small' } }} />
      <GridToolbarQuickFilter />

      <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}>
        <Switch
          size="small"
          checked={loadsCombined}
          onChange={event => onLoadsCombinedChange(event.target.checked)}
        />
        <Box component="span" sx={{ fontSize: 12 }}>
          Lasten zusammenfassen
        </Box>
      </Box>
    </Stack>
  </GridToolbarContainer>
)

export default LoadResultsToolbar
